import Typography from "antd/lib/typography";
import clsx from "clsx";

import { Avatar } from "@sol/uikit/data-display/Avatar/Avatar";
import { Tag } from "@sol/uikit/data-display/Tag/Tag";

type Props = {
    title: string;
    locale: string;
    description?: string;
    prominent?: boolean;
    className?: string;
};

const LanguageFlag = ({ locale, prominent }: Pick<Props, "locale" | "prominent">) => {
    const flagCode = locale.substring(0, 2);

    return (
        <Avatar
            src={`/static/flags/${flagCode}.svg`}
            alt=""
            size={prominent ? 64 : 48}
            className="shrink-0 bg-ant-fill-secondary"
            aria-hidden="true"
        >
            {flagCode.toUpperCase()}
        </Avatar>
    );
};

export const LanguageIdentity = ({ title, locale, description, prominent = false, className }: Props) => (
    <div className={clsx("flex min-w-0 items-center gap-ant-sm", className)} lang={locale}>
        <LanguageFlag locale={locale} prominent={prominent} />
        <div className="min-w-0">
            <div
                className={clsx(
                    "flex min-w-0 flex-wrap",
                    prominent ? "items-center gap-ant-xxs" : "flex-col items-start",
                )}
            >
                {prominent ? (
                    <Typography.Title level={2} className="mb-0! min-w-0 truncate">
                        {title}
                    </Typography.Title>
                ) : (
                    <Typography.Text strong className="min-w-0 truncate text-ant-lg">
                        {title}
                    </Typography.Text>
                )}
                <Tag bordered className="m-0! shrink-0 font-ant-strong tracking-wide uppercase">
                    {locale}
                </Tag>
            </div>
            {description ? (
                <Typography.Text type="secondary" className="mt-ant-xxs block">
                    {description}
                </Typography.Text>
            ) : null}
        </div>
    </div>
);
